import { render, staticRenderFns } from "./FaqCategoryForm.vue?vue&type=template&id=638fd533&"
import script from "./FaqCategoryForm.vue?vue&type=script&lang=js&"
export * from "./FaqCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./FaqCategoryForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports